import { CustomerMaterial } from 'components/Sales/CustomerMaterial'
import React, { Component } from 'react'
import { Avatar, Breadcrumb, Button, Card, Icon, Layout, message, Row, Select, Tabs } from 'antd'
import ClientsApi from '../../api/Sales/Clients'

import style from './style.css'
import { arrVal, filterCheckedColumns, sessionItemVal, strVal } from '../../modules/Utils'
import { get } from 'lodash'
import { Link, withRouter } from 'react-router-dom'
import { streamUrl } from '../../variables/index'
import Authentication from '../../modules/Authentication'
import CustomTable from '../../elements/Table/CustomTable'
import Status from '../../elements/Status'
import State from '../../elements/State'
import SalesContractsApi from '../../api/Sales/SalesContracts'
import CentersCascader from '../../elements/Cascader/CentersCascader'
import DateCell from '../../elements/Table/Cells/DateCell'
import StatusCell from '../../elements/Table/Cells/StatusCell'
import BoolFilter from '../../elements/Select/BoolFilter'
import BoolCell from '../../elements/Table/Cells/BoolCell'

const { Content } = Layout

const { TabPane } = Tabs

const NewClientButton = withRouter(({ history }) => {
  return (
    <Button
      type="primary"
      icon={'plus'}
      onClick={() => {
        history.replace('/clients/new')
      }}>
      New
    </Button>
  )
})

class Clients extends Component {
  api = new ClientsApi()
  salesContractsApi = new SalesContractsApi()
  state = {
    list: [],
    data: [],
    fetching: false,
    searchWord: '',
  }
  pagination = {
    pageSize: 8,
    showSizeChanger: true,
    pageSizeOptions: ['12', '24', '30', '60'],
    showTotal: (total) => {
      return `${total} Record`
    },
  }
  auth = new Authentication()
  columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Kind',
      accessor: 'member.kind',
      hideable: true,
      hideDefault: false,
      width: 180,
    },
    {
      Header: 'Code',
      accessor: 'code',
      width: 150,
      Cell: ({ value, original }) => (
        <a onClick={() => (window.location = `#clients/${original.member._key}/`)}>
          {get(original, 'member.image') ? (
            <Avatar
              src={`${streamUrl}files/${original.member.image}?action=view&access_token=${this.auth.getAccessToken()}`}
            />
          ) : (
            <Avatar icon="global" />
          )}
          <span style={{ marginLeft: '10px' }}>{value}</span>
        </a>
      ),
    },
    {
      Header: 'Full Name',
      accessor: 'member.fn',
      //width: 500
    },
    {
      Header: 'Group Co',
      accessor: 'partnerGroup.group',
      hideable: true,
      hideDefault: false,
      width: 200,
    },
    {
      Header: 'Group Remittance',
      accessor: 'partnerGroup.remittance',
      filterMethod: filterCheckedColumns,
      Filter: BoolFilter,
      Cell: BoolCell,
      hideable: true,
      hideDefault: false,
      width: 200,
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 150,
      Cell: StatusCell,
      filterMethod: (filter, row) => {
        const activeArray = ['Active']
        const nonActiveArray = ['Inactive']
        if (filter.value === 'all') {
          return true
        }
        return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
      },
      Filter: ({ onChange, filter }) => (
        <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
          <Select.Option value="all">All</Select.Option>
          <Select.Option value={true}>Active</Select.Option>
          <Select.Option value={false}>None Active</Select.Option>
        </Select>
      ),
    },
  ]
  subColumns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Code',
      accessor: 'code',
      width: 150,

      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/clients/${strVal(original, 'owner._id').replace('members/', '')}/contracts/${
              original._key
            }/view`,
          }}
          style={{ marginLeft: '10px' }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Main Contract',
      accessor: 'isMainContract',
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'Client',
      accessor: 'client.fn',
      width: 450,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/clients/${strVal(original, 'owner._id').replace('members/', '')}/`,
          }}
          style={{ marginLeft: '10px' }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Business Registration',
      accessor: 'client.companyno',
    },
    {
      Header: 'Tax Registration',
      accessor: 'client.taxRegistration',
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
    },
    {
      Header: 'Centers',
      accessor: 'center.name',
    },
    {
      Header: 'Expiry Date',
      accessor: 'date.expiry',
      Cell: DateCell,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Services State',
      accessor: 'state',
      width: 150,
      Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
    },
    {
      Header: 'Billing State',
      accessor: 'billingState',
      width: 150,
      Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
    },
    {
      Header: 'Document Status',
      accessor: 'status',
      width: 150,
      Cell: StatusCell,
      filterMethod: (filter, row) => {
        const activeArray = ['Approved']
        const revisionArray = ['Draft', 'Submitted', 'Resubmitted', 'Revised']
        const nonActiveArray = ['Rejected', 'Closed', 'Cancelled']
        if (filter.value === 'all') {
          return true
        }
        if (filter.value === 'revision') {
          return revisionArray.includes(row[filter.id])
        }
        return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
      },
      Filter: ({ onChange, filter }) => (
        <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
          <Select.Option value="all">All</Select.Option>
          <Select.Option value={true}>Active</Select.Option>
          <Select.Option value="revision">In Progress</Select.Option>
          <Select.Option value={false}>None Active</Select.Option>
        </Select>
      ),
    },
  ]

  componentDidMount() {
    this.fetch()
    this.fetchContracts()
  }

  fetch = async () => {
    try {
      this.setState({ fetching: true })
      let list = await this.api.list()
      this.setState({ data: list, list, fetching: false })
    } catch (err) {
      message.error(err.errorMessage)
      this.setState({ fetching: false })
    }
  }

  filterByCenter = (center) => {
    this.setState((prvState) => ({
      center: center,
      contracts:
        center.length > 0
          ? prvState.cachedContracts.filter((c) => arrVal(c, 'budget.cost._id').includes(center[center.length - 1]))
          : prvState.cachedContracts,
    }))
  }

  fetchContracts = async () => {
    try {
      this.setState({ fetchingContracts: true })
      let list = await this.salesContractsApi.list()
      this.setState({
        contracts: list,
        center: undefined,
        cachedContracts: list,
        fetchingContracts: false,
      })
    } catch (err) {
      message.error(err.errorMessage)
      this.setState({ fetchingContracts: false })
    }
  }

  render() {
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Sales</Breadcrumb.Item>
              <Breadcrumb.Item>Client List</Breadcrumb.Item>
            </Breadcrumb>
            <h1 className={style.title}>
              <Icon type="user" style={{ marginRight: 10, color: '#3583c9' }} />
              Clients
            </h1>
            <p className={style.paragraph}>List of all clients in system. You can filter or create a new client.</p>
          </Row>
        </Card>
        <Card className={style.contentCard}>
          <Tabs
            defaultActiveKey={get(this.props, 'location.hash') || '#contracts'}
            onChange={(key) => this.props.history.push(key)}>
            <TabPane
              tab={
                <span>
                  <Icon type="user" />
                  Clients Listing
                </span>
              }
              key="#users">
              <CustomTable
                CreateButton={() => <NewClientButton />}
                isFilterable={true}
                columns={this.columns}
                data={this.state.list}
                fetching={this.state.fetching}
                fetch={this.fetch}
              />
            </TabPane>

            <TabPane
              tab={
                <span>
                  <Icon type="windows"/> Material Search
                </span>
              }
              key="#customermaterial">
              <CustomerMaterial type={'sales'}/>
            </TabPane>
            <TabPane
              tab={
                <span>
                  <Icon type="book" />
                  Sales Accounts
                </span>
              }
              key="#contracts">
              <span>Filter By Profit Centers : </span>
              <CentersCascader
                id={'centers'}
                category={'Profit'}
                style={{ marginLeft: 10, width: 300 }}
                size={'small'}
                placeholder={'Filter by Profit Center'}
                value={this.state.center}
                onChange={this.filterByCenter}
                changeOnSelect
              />
              <CustomTable
                defaultSorted={[
                  {
                    id: 'client.fn',
                    desc: false,
                  },
                ]}
                defaultFiltered={[
                  {
                    id: 'status',
                    value: true,
                  },
                ]}
                isFilterable={true}
                columns={this.subColumns}
                data={this.state.contracts}
                fetching={this.state.fetchingContracts}
                fetch={this.fetchContracts}
              />
            </TabPane>
            {/*<TabPane*/}
            {/*tab={*/}
            {/*<span>*/}
            {/*<Icon type="lock" />*/}
            {/*Accounts*/}
            {/*</span>*/}
            {/*}*/}
            {/*key="#accounts">*/}
            {/*<AccountsCont />*/}
            {/*</TabPane>*/}
          </Tabs>
        </Card>
      </Content>
    )
  }
}

Clients.propTypes = {}
Clients.defaultProps = {}

export default withRouter(Clients)
